export var chatRoomDbScheme = {
    name: 'chatroom',
    properties: {
        id: { type: 'varchar', primary: true },
        isArchived: { type: 'boolean', nullable: true },
        isTemporary: { type: 'boolean', nullable: true },
        participantId: { type: 'varchar', nullable: true },
        isPrivate: { type: 'boolean', nullable: true },
        cursor: { type: 'int', nullable: true },
        lastMessage: { type: 'blob', nullable: true },
        lastMessages: { type: 'blob', nullable: true },
        lastReadMessageSequence: { type: 'int', nullable: true },
        lastSeenMessageSequence: { type: 'int', nullable: true },
        unreadCount: { type: 'int', nullable: true },
        offlineChannels: { type: 'blob', nullable: true },
        displayData: { type: 'blob', nullable: true },
        status: { type: 'blob', nullable: true },
        sortRank: { type: 'int', nullable: true },
        participantCount: { type: 'int', nullable: true },
        clientReference: { type: 'varchar', nullable: true },
        clientReferenceType: { type: 'varchar', nullable: true },
        createdAt: { type: 'int', nullable: true },
        createdBy: { type: 'varchar', nullable: true },
        businessContext: { type: 'blob', nullable: true },
        pluginName: { type: 'varchar', nullable: true },
        enrichedChatroomLoaded: { type: 'boolean', nullable: true },
        labelIds: { type: 'blob', nullable: true },
        messageDeliveryError: { type: 'boolean', nullable: true },
    }
};
export var messageDbScheme = {
    name: 'message',
    properties: {
        id: { type: 'varchar', primary: true },
        chatroomId: { type: 'varchar', nullable: false },
        messageType: { type: 'varchar', nullable: true },
        messageTypeVersion: { type: 'int', nullable: true },
        sender: { type: 'blob', nullable: true },
        createdAt: { type: 'int', nullable: true },
        sequence: { type: 'int', nullable: true },
        pluginName: { type: 'blob', nullable: true },
        data: { type: 'blob', nullable: true },
        templateData: { type: 'blob', nullable: true },
        summary: { type: 'varchar', nullable: true },
        senderDisplayData: { type: 'blob', nullable: true },
        isEphemeral: { type: 'boolean', nullable: true },
        isSilent: { type: 'boolean', nullable: true },
        badges: { type: 'blob', nullable: true },
        distribution: { type: 'blob', nullable: true },
        transit: { type: 'blob', nullable: true },
        deliveryMethods: { type: 'blob', nullable: true },
    }
};
export default { messageDbScheme: messageDbScheme, chatRoomDbScheme: chatRoomDbScheme };
